import { render, staticRenderFns } from "./exchangeSuccess.vue?vue&type=template&id=51c7e4c7&scoped=true&"
import script from "./exchangeSuccess.vue?vue&type=script&lang=js&"
export * from "./exchangeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./exchangeSuccess.vue?vue&type=style&index=0&id=51c7e4c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c7e4c7",
  null
  
)

export default component.exports